// API origin is env-driven: production defaults to same-origin (empty string),
// since the SPA + API are now both served from zencricketdata.com via CloudFront
// (CloudFront proxies /api/* and /admin/* etc. to the EC2 backend).
// Override locally via .env.local with VITE_API_BASE_URL=http://localhost:8000.
const RAW_API_ORIGIN =
  import.meta.env.VITE_API_BASE_URL ?? "";

export const API_ORIGIN = RAW_API_ORIGIN.replace(/\/+$/, "");

export const API_BASE_URL = API_ORIGIN.endsWith("/api")
  ? API_ORIGIN
  : `${API_ORIGIN}/api`;
